import { EMPTY_OBJECT } from '../../../constants/common'
import {
  DragDropDroppableArea,
  DragDropProvider,
  DragDropSortableItem,
  DragDropSortableList,
} from '../../DragDrop'
import Text from '../../Text'
import { BIRDVIEW_DRAGGING_ITEM_STYLE } from '../DashboardBirdview.constants'

import {
  BIRDVIEW_LAYOUT_COLUMN,
  BIRDVIEW_SORTABLE_WIDGET_TYPE,
} from './BirdviewLayout.constants'
import { useBirdviewLayout } from './BirdviewLayout.hooks'

import * as styles from './BirdviewLayout.module.css'

function BirdviewLayout({
  defaultLayout,
  overlayTitles = EMPTY_OBJECT,
  storageKeyPrefix,
  widgets,
}) {
  const {
    handleDragCancel,
    handleDragEnd,
    handleDragOver,
    handleDragStart,
    layout,
  } = useBirdviewLayout({ defaultLayout, storageKeyPrefix })

  function renderColumn(column) {
    return (
      <DragDropDroppableArea className={styles.column} id={column}>
        <DragDropSortableList
          className={styles.columnList}
          id={column}
          items={layout[column]}
        >
          {layout[column].map(id => (
            <DragDropSortableItem
              withDragHandle
              className={styles.item}
              draggingStyle={BIRDVIEW_DRAGGING_ITEM_STYLE}
              id={id}
              key={id}
              sortableProps={{ data: { type: BIRDVIEW_SORTABLE_WIDGET_TYPE } }}
            >
              {widgets[id]}
            </DragDropSortableItem>
          ))}
        </DragDropSortableList>
      </DragDropDroppableArea>
    )
  }

  function renderOverlay(activeId) {
    const title = overlayTitles[activeId]

    return title ? (
      <Text Element='div' className={styles.overlay}>
        {title}
      </Text>
    ) : null
  }

  return (
    <DragDropProvider
      renderOverlay={renderOverlay}
      onDragCancel={handleDragCancel}
      onDragEnd={handleDragEnd}
      onDragOver={handleDragOver}
      onDragStart={handleDragStart}
    >
      <div className={styles.grid}>
        {renderColumn(BIRDVIEW_LAYOUT_COLUMN.left)}
        {renderColumn(BIRDVIEW_LAYOUT_COLUMN.right)}
      </div>
    </DragDropProvider>
  )
}

export default BirdviewLayout
